import React from 'react';
import ReactDOM from 'react-dom/client';

/** Mount a print overlay (same pattern as PayrollPeriodDetailPage). */
export function openHrmsPrintOverlay(render: (onClose: () => void) => React.ReactElement) {
  const main = document.getElementById('root');
  const el = document.createElement('div');
  el.id = 'print-container';
  document.body.appendChild(el);
  if (main) main.style.display = 'none';
  const root = ReactDOM.createRoot(el);
  const cleanup = () => {
    root.unmount();
    el.parentNode?.removeChild(el);
    if (main) main.style.display = 'block';
    window.removeEventListener('afterprint', cleanup);
  };
  root.render(render(cleanup));
  window.addEventListener('afterprint', cleanup);
  setTimeout(() => window.print(), 350);
}
